export default {
  noComments: 'No comments.',
  addComment: 'Add Comment',
  observationSaved: 'Observation saved.',
  observationUpdated: 'Observation updated.',
  commentSaved: 'Comment saved.',
  commentUpdated: 'Comment updated.',
};
